import * as Sentry from "@sentry/react";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import SentryErrorBoundary from './components/SentryErrorBoundary';
import './fonts.css';
import './tokens.css';
import './index.css';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: import.meta.env.PROD,

  ignoreErrors: [
    // Instagram in-app browser native bridge errors
    'Invalid call to runtime.sendMessage',
    'Error invoking postMessage: Java object is gone',
    "undefined is not an object (evaluating 'window.webkit.messageHandlers')",
    // Other common browser extension / WebView noise
    'postMessage',
    'sendDataToNative',
    'navigation_performance_logger',
  ],

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <SentryErrorBoundary>
    <App />
  </SentryErrorBoundary>
);